<template>
	<div class="Tickets">
		<div class="buttons">
			<vs-button
				v-if="$store.state.auth.role === 'manager'"
				@click="$router.push('/ticket/create')"
			>{{ $t('addTicket') }}</vs-button>
		</div>
		<vx-card class="my-8">
			<vs-tabs :value="activeTabItem" @setActiveTab="setActiveTab" v-if="tabs.length > 0">
				<vs-tab
					v-for="(tab, tabIndex) in tabs"
					:key="tab.title"
					:counter="getTabCounter(orders[tab.key])"
					:count="counters[tabIndex]"
					:label="$t(tab.title)"
				>
					<div class="filter vx-row lg:flex-row flex-col-reverse" v-if="$store.state.auth.role === 'manager'">
						<div class="date vx-col w-full xl:w-8/12 flex">
							<div class="vx-row w-full xl:w-auto flex-1">
								<div
									class="vs-component vs-con-input-label vs-input vs-input-primary vx-col w-1/2 sm:w-1/3 xl:w-auto mt-3"
								>
									<div class="vs-con-input"></div>
									<vs-datepicker
										v-model="off"
										format="dd.MM.yyyy"
										:placeholder="$t('from')"
										name="date"
										class="w-full xl:w-auto tickets__datepicker"
									></vs-datepicker>
								</div>
								<div
									class="vs-component vs-con-input-label vs-input vs-input-primary vx-col w-1/2 sm:w-1/3 xl:w-auto mt-3"
								>
									<div class="vs-con-input"></div>
									<vs-datepicker
										v-model="to"
										format="dd.MM.yyyy"
										:placeholder="$t('to')"
										name="date"
										class="w-full xl:w-auto tickets__datepicker"
									></vs-datepicker>
								</div>
								<div
									class="vs-component vs-con-input-label vs-input vs-input-primary vx-col w-1/2 sm:w-1/3 mt-3"
								>
									<v-select
										v-model="selectedManager"
										:reduce="item => item.id"
										:options="filteredManagers"
										:placeholder="$t('manager')"
										label="full_name"
										class="single-row-select w-full"
									/>
								</div>
								<div class="vx-col w-full sm:w-1/3 xl:w-auto mt-3">
									<vs-custom-button
										color="dark"
										type="border"
										@click="(off = ''), (to = '')"
										class="vs-custom-button w-full xl:w-auto pl-1 pr-1 lg:pl-10 lg:pr-10"
									>{{ $t('reset') }}</vs-custom-button>
								</div>
								<div
									class="vs-component vs-con-input-label vs-input vs-input-primary vx-col w-1/2 sm:w-1/3 mt-3"
								>
									<v-select
										v-model="selectedOrderType"
										:reduce="item => item.id"
										:options="orderTypeOptions"
										placeholder="Order type"
										label="label"
										:clearable="true"
										class="single-row-select w-full"
									/>
								</div>
							</div>
						</div>
						<div class="vx-col w-full  xl:w-4/12 flex">
							<div class="vx-row w-full xl:w-auto flex-1">
								<div class="search vx-col flex items-end w-full lg:w-1/2 xl:w-1/2 mt-3">
									<vs-input
										v-model="search"
										:placeholder="$t('searchByNameAndClient')"
										icon="search"
										icon-after
										@input="filter()"
									/>
								</div>
								<div class="search vx-col flex items-end w-full lg:w-1/2 xl:w-1/2 mt-3">
									<vs-input
										v-model="cid"
										:placeholder="$t('searchByCid')"
										icon="search"
										icon-after
										@input="filter()"
									/>
								</div>
								<div class="search vx-col flex items-end w-full lg:w-1/2 xl:w-1/2 mt-3">
									<vs-input
										v-model="phone"
										:placeholder="$t('searchByPhone')"
										icon="search"
										icon-after
										@input="filter()"
									/>
								</div>
							</div>
						</div>
					</div>
					<AdminFilters
						v-else-if="$store.state.auth.role === 'admin'"
						:levels="levels"
						:works="works"
						:selectedManager.sync="selectedManager"
						:selectedAuthor.sync="selectedAuthor"
						:selectedClient.sync="selectedClient"
						:selectedWebsite.sync="selectedWebsite"
						:selectedLevel.sync="selectedLevel"
						:selectedWork.sync="selectedWork"
						:selectedOrderType.sync="selectedOrderType"
						:selectedOff.sync="off"
						:selectedTo.sync="to"
						:selectedName.sync="search"
						:selectedCid.sync="cid"
						:selectedPhone.sync="phone"
						@search="filter"
					/>
					<div class="tab-text">

						<div class="total-tickets mt-4 ml-1">{{ $t('totalWorks') }}
							<span>: {{ totalTickets }}</span>
						</div>
						<vs-table
							:sst="true"
							:total="totalTickets"
							:max-items="10"
							:data="searchedOrders[tab.key]"
							:currentPage="currentPage"
							pagination
							@change-page="setPageNumber"
							@sort="sortTab"
						>
							<template slot="thead">
								<vs-th
									v-for="fil in field"
									v-if="!(tab.key === 'basket' && fil.field === 'task')"
									showSort
									:keyForSorting="fil.field"
									@setSortKey="setSortKey"
									:class="{ 'author-header': fil.field === 'author.username' }"
								>
									{{ $t(fil.title) }}
								</vs-th>
								<!-- <vs-th
									v-if="tab.key === 'basket'"
									:sort-key="'basket'.split('.')[0]"
									class=""
								>
									{{ $t('actions') }}
								</vs-th> -->
								<vs-th
									v-if="tab.key === 'basket'"
									:sort-key="'basket'.split('.')[0]"
									class=""
								>
									{{ $t('reason') }}
								</vs-th>
							</template>

							<template slot-scope="{ data }">
								<vs-tr
									:key="indextr"
									v-for="(tr, indextr) in data"
									:class="{ 'deal-today': hasDealToday(tr) }"
								>
									<template v-for="fil in field">
										<vs-td v-if="fil.field === 'name'">
											<router-link :to="'ticket/' + tr.id">
												{{ tr.name }}
											</router-link>
										</vs-td>

										<vs-td v-else-if="fil.field === 'client.full_name'">
											<router-link :to="`${pathToClient}/${ deepFind(tr, 'client.id')}`">
												{{ deepFind(tr, fil.field) || '---' }}
											</router-link>
										</vs-td>

										<vs-td v-else-if="fil.field === 'author.username'">
											<router-link
												v-if="tr[fil.field.split('.')[0]]"
												:to="`${pathToAuthor}/${deepFind(tr, 'author.id')}`"
												class="flex justify-center text-center"
											>
												{{ deepFind(tr, fil.field) || '---' }}
											</router-link>
										</vs-td>

										<vs-td v-else-if="fil.field === 'chat_messages_count'">
											<!-- add later || tr.author_is_chat_unread -->
											<div class="counters__container">
												<span
													v-if="$store.state.auth.role === 'admin'
													|| $store.state.auth.role === 'manager'"
													class="counter cursor-pointer"
													:class="{ blue: tr.author_is_chat_unread }"
													@click="openAuthorChat(tr.id)"
												>
													{{ (tr.author_chat_messages_count || 0) }}
												</span>
												<span
													class="counter cursor-pointer"
													:class="{ warn: tr.is_chat_unread }"
													@click="$store.dispatch('openChat',{
														id: tr.id,
														disabled: !isNotCompleted
													})"
												>
													{{ tr.chat_messages_count || 0 }}
												</span>
												<span
													v-if="($store.state.auth.role === 'admin'
													|| $store.state.auth.role === 'manager') && tr.sendpulse_unsubscribed "
													class="cursor-pointer ml-2"
													title="Client unsubscribed from sendpulse"
												>
													<vs-icon icon="cancel_schedule_send" size="small" color="red"></vs-icon>
												</span>
												<span
													v-if="($store.state.auth.role === 'admin'
													|| $store.state.auth.role === 'manager') && tr.mailjet_unsubscribed "
													class="cursor-pointer ml-2"
													title="Client unsubscribed from Mailjet"
												>
													<vs-icon icon="cancel_schedule_send" size="small" color="orange"></vs-icon>
												</span>
											</div>
										</vs-td>

										<vs-td v-else-if="fil.field === 'id'">
											<router-link :to="'ticket/' + tr.id">
												{{ deepFind(tr, fil.field) || '---' }}
											</router-link>
										</vs-td>

										<vs-td v-else-if="fil.field === 'subject'">
											{{ $getDeep(tr.subject, subjects) }}
										</vs-td>

										<vs-td v-else-if="fil.field === 'have_manager'">
											<div class="agent-circle-wrapper">

												<div v-if="tr.manager && tr.manager.id" class="agent-circle agent-red"></div>

												<div v-else class="agent-circle agent-green"></div>
											</div>
										</vs-td>

										<vs-td v-else-if="fil.field === 'work_type'">
											{{ $getDeep(tr.work_type, works) }}
										</vs-td>

										<vs-td v-else-if="fil.field === 'quality_level'">
											{{ $getDeep(tr.quality_level, levels) }}
										</vs-td>
										<vs-td v-else-if="fil.field === 'contact_time'">
											<vs-alert v-if="tr.contact_time" color="warning">
												{{ tr.contact_time }}
											</vs-alert>
										</vs-td>

										<vs-td v-else-if="fil.field === 'site'">
											<span v-if="tr.client">
												{{ tr.client.site }}
											</span>
										</vs-td>

										<vs-td v-else-if="fil.field === 'manager.username' && tr.manager !== null">
											{{ tr.manager.username }}
										</vs-td>

										<vs-td v-else-if="fil.field === 'milestones' && tr.manager !== null">
											{{ tr.milestones_count }}
										</vs-td>

										<vs-td v-else-if="fil.field === 'price' && tr.manager !== null">
											{{ tr.price_author }}
										</vs-td>

										<vs-td v-else-if="tab.key !== 'basket' && fil.field === 'task'">
											<span
												class="task cursor-pointer flex"
												  v-if="tr[fil.field]"
												  @click="editTask(tr.id, tr.task)"
											>
                                                {{ tr[fil.field].date_time | moment('DD.MM.YYYY HH:mm') }}
                                            </span>
											<span
												class="task cursor-pointer"
												@click="idOrder = tr.id;activePrompt = true"
												v-else
											>+</span>

										</vs-td>
										<vs-td v-else-if="tr[fil.field]">
											{{ tr[fil.field] }}
										</vs-td>
										<vs-td v-else-if="!(tab.key === 'basket' && fil.field === 'task')">
											...
										</vs-td>
									</template>
									<!-- <vs-td class="text-center" v-if="tab.key === 'basket'">
										<span
											class="cursor-pointer text-success"
											@click="showRestoreFromBasketDialog(tr)"
										>
											<feather-icon badge size="1.5x" icon="Trash2Icon"></feather-icon>
										</span>

									</vs-td> -->
									<vs-td class="text-center" v-if="tab.key === 'basket'">
										<span
											class="text-warning"
											:class="{ 'text-orange': tr.reason.toLowerCase() === 'архив' || tr.reason.toLowerCase() === 'archiv' }"
										>
											{{tr.reason || '...'}}
										</span>

									</vs-td>
								</vs-tr>
							</template>
						</vs-table>

						<div
              v-if="$store.state.auth.role === 'admin'" class="download__container"
            >
							<vs-custom-button
                v-if="invoices"
                :disabled="isDisabled"
								color="dark"
								type="border"
								class="vs-custom-button vs-button-text"
								@click="downloadDataFromLink(invoices)"
							>
                {{ $t("download") }}
								<feather-icon svgClasses="h-5 w-5" class="feather-icon" icon="DownloadIcon" />
							</vs-custom-button>

              <vs-custom-button
                v-if="payoutActs"
                :disabled="isDisabled"
                color="dark"
								type="border"
								class="vs-custom-button vs-button-text"
                @click="downloadDataFromLink(payoutActs)"
              >
                {{ $t("downloadActs") }}
								<feather-icon svgClasses="h-5 w-5" class="feather-icon" icon="DownloadIcon" />
							</vs-custom-button>
						</div>
					</div>
				</vs-tab>
			</vs-tabs>
		</vx-card>

		<CreateOrderTask
			:active.sync="activePrompt"
			:date.sync="date"
			:about.sync="about"
			@create-task="createTask"
		/>

		<vs-popup class="viewTask" :title="$t('taskView')" :active.sync="popupActiv">
			<div class="body" v-if="task.order">
				<table>
					<tr>
						<td><b>{{ $t('date') }}</b></td>
						<td>{{ task.date_time | moment("DD.MM.YYYY") }}</td>
					</tr>
					<tr>
						<td><b>{{ $t('ticket') }}</b></td>
						<td>
							<router-link :to="'ticket/' + task.order.id">
					<span @click="popupActiv = false">
						№{{ task.order.id }}
					</span>
							</router-link
							>
						</td>
					</tr>
				</table>
				<b>{{ $t('description') }}</b>
				<p>
					{{ task.description }}
				</p>
			</div>
			<div class="footer" v-if="task">
				<vs-button
					color="danger"
					:disabled="task.is_by_admin"
					@click="closeTask(task.order, task.id)"
				>
					{{ task.is_by_admin ? $t('setByAdmin') : $t('delete') }}
				</vs-button>

				<vs-button
					color="success"
					@click="completeTask(task.order, task.id)"
				>{{ $t('done') }}</vs-button>
			</div>
		</vs-popup>
	</div>
</template>

<script>
import AdminFilters from './AdminFilters';
import tasksListMixin from "@/mixins/tickets-list-mixin";
import Datepicker from "vuejs-datepicker";
import databaseManager from "@/mixins/databaseManager";
import notifier from "@/mixins/notifier";
import orderHeadersList from "@/assets/configs/orderHeadersList";
import vSelect from "vue-select";
import CreateOrderTask from "@/components/dialogs/CreateOrderTask.vue";

export default {
	name: "Tickets",
	components: {
		Datepicker,
		AdminFilters,
        vSelect,
		CreateOrderTask
	},
	mixins: [databaseManager, notifier, tasksListMixin],
	data() {
		return {
			sortKey: null,
			sortType: null,

			counters: [],
			totalTickets: 1,
			currentPage: 1,
			activeTabItem: 0,
			isDisabled: false,
			idOrder: 0,
			date: new Date(),
			// indexTab: 0,
			off: "",
			to: "",
			search: "",
			cid: "",
			phone: "",
			id: '',
			selectedManager: null,
			selectedOrderType: null,
			selectedAuthor: null,
			selectedClient: null,
			selectedWebsite: null,
			selectedWork: null,
			selectedLevel: null,
			about: "",
			activePromptCounter: 0,
			activePrompt: false,
			popupActiv: false,
			task: {},
			tabs: [],
			orders: {
				new: [],
				new_ppg: [],
				in_progress: [],
				work_long_term: [],
				waiting_approve: [],
				completed: [],
				offer_sent: [],
				client_not_answer: [],
				processing: [],
				waiting_payment: [],
				waiting_author: [],
				failed: [],
				failed_with_payout: [],
				additional_sale: [],
				basket: [],
			},
			tabsHasMessageSet: new WeakSet(),
			subjects: [],
			works: [],
			levels: [],
			tasks: [],
			field: [],
			invoices: null,
			payoutActs: null,
			managers: [],
			currentManager: null,
			orderTypeOptions: [
				{ id: 1, label: 'PPG Orders' },
				{ id: 0, label: 'Basic orders' },
			]
		};
	},
	methods: {
		async openAuthorChat(id) {
			const model = await this.dbViewOrder(id);
			this.$store.dispatch('openChat',{
				authorChatId: model.author_chat_id,
				orderId: id,
				disabled: !this.isNotCompleted
			})
		},
		showRestoreFromBasketDialog(order) {
			this.$vs.dialog({
				color: "success",
				title: this.$t(`confirmUnblockingOrder`),
				acceptText: this.$t(`confirm`),
				cancelText: this.$t(`doCancel`),
				text: this.$t('confirmUnblockingOrder') + " №" + order.id,
				accept: async () => {
					try {
						const response = (await this.$http.post(
							`/${this.$store.state.auth.role}/order/activate/${order.id}`
						)).data;
						if (response.status === 200 && response.data.set_active_status) {
							this.notifySuccess(this.$t('orderRestoredSuccessfully'));
							await this.filter();
						} else {
							throw new Error('Something went wrong')
						}
					} catch (e) {
						this.notifyError(e.message);
					}
				},
			});
		},

		async checkInvoices(off, to) {
			const invoices =  await this.dbDownloadInvoices(off, to);
			if (!invoices.length) {
				this.invoices = null
      } else {
				this.invoices = invoices;
			}
		},

		async checkPayoutActs(off, to) {
			const payoutActs =  await this.dbDownloadActs(off, to);
			if (!payoutActs.length) {
        this.payoutActs = null
      } else {
				this.payoutActs = payoutActs
			}
		},

		async downloadDataFromLink(data) {
				this.isDisabled = true;
				try {
					if (!data) {
            return
          }

          const link = document.createElement("a");
          link.href = data;
          link.setAttribute("download", "file.zip");
          document.body.appendChild(link);
          link.click();
				} catch (e) {
					this.notifyError(e.message);
				} finally {
          setTimeout(() => {
            this.isDisabled = false;
          }, 2000);
        }

		},
		getTabCounter(orders) {
			return {
				value: orders.length,
				color: this.tabsHasMessageSet.has(orders) ? "orange" : undefined
			};
		},
		hasDealToday(tr) {
			if(!tr || !tr.task) return false;

			const [date] = tr.task.date_time.split(" ");
			const [year, month, day] = date.split("-");

			const current = new Date();
			const cYear = current.getFullYear();
			let cMonth = current.getMonth() + 1;
			cMonth = cMonth >= 10 ? cMonth : '0' + cMonth;
			let cDay = current.getDate();
			cDay = cDay >= 10 ? cDay : '0' + cDay;

			return +year === +cYear
				&& +month === +cMonth
				&& +day === +cDay;
		},
		async completeTask(order, taskId) {
			try {
				await this.$http.post(
					`/${this.$store.state.auth.role}/task/complete/${taskId}`, { is_completed: true }
				);
				this.notifySuccess(this.$t("completedSuccessfully"));
				this.popupActiv = false;

				const ticket = this.findTicketAnywhere(order.id);

				if(!!ticket) {
					ticket.task = null;
				}
			} catch (e) {
				this.notifyError(e.message);
			}
		},
		async closeTask(order, taskId) {
			try {
				await this.$http.post(
					"/" + this.$store.state.auth.role + "/task/delete/" + taskId
				);
				this.notifySuccess(this.$t("deletedSuccessfully"));

				this.popupActiv = false;

				const ticket = this.findTicketAnywhere(order.id);

				if(!!ticket) {
					ticket.task = null;
				}

			} catch (e) {
				this.notifyError(e.message);
			}
		},
		setSortKey(key) {
			if (key === 'created') key = 'date';
			if (key === 'pages_number') key = 'pages';
			this.sortKey = key;
		},
		sortTab(key, type) {
			this.sortType = type;
			// this.orders[tab].sort((a, b) => {

				// if(!b.task && a.task) return -1;
				// if(!a.task && b.task) return 1;
				// if(!a.task && !b.task) return 0;

				// if(a.task.date_time > b.task.date_time) return 1;
				// if(a.task.date_time < b.task.date_time) return -1;

				// return 0;
			// });
		},
		sortTickets() {
			for(let tab in this.orders) {
				this.sortTab(tab);
			}
		},

		findTask(id) {
			let res = this.tasks.filter(
				(task) => (task.order && task.order.id) === id
			)[0];
			return !!res ? res : null;
		},
		deepFind(obj, path) {
			if (!path) return "";
			let paths = path.split("."),
				current = obj,
				i;

			for (i = 0; i < paths.length; ++i) {
				if (current[paths[i]] === undefined) {
					return undefined;
				} else {
					current = current[paths[i]];
				}
			}
			return current;
		},
		addSortWrappers(tab) {
			for (let item of this.orders[tab.key]) {
				if (item && item.client) {
					item.client.toString = function () {
						return this.full_name;
					}
				} else {
					item.client = "";
				}

				if (item.author) {
					item.author.toString = function () {
						return this.username;
					}
				} else {
					item.author = "";
				}

				if (item.task) {
					item.task.toString = function () {
						return this.date_time;
					}
				} else {
					item.task = "";
				}
			}
		},

		async filterCountNoReplyOrder(options = null) {

			this.counters = this.tabs.map(() => 0)

			const requests = []
			try {

				for (let i = 0; i < this.tabs.length; i++) {

					const item = this.tabs[i];

					let requestOptions = options || {
						off: this.off,
						to: this.to,
						limit: 0,
						name: this.search,
						manager: this.selectedManager,
					};
					requestOptions.type = item.key;

					requests.push(async () => {
						let dataTickets = await this.dbGetFilteredTickets(requestOptions);
						item.count = dataTickets.count_no_reply_order;

						this.$set(this.counters, i, item.count)

						const unreadOrder = item.count

						if (unreadOrder !== undefined && unreadOrder >= 0) {
							this.tabsHasMessageSet.add(this.orders[item.key]);
						}

						this.addSortWrappers(item);
					})

				}

				await Promise.all(requests.map(item => item()))

			} catch (e) {
				this.notifyError(e.message);
			}
		},

		async filter(options = null) {
			let item = this.tabs[this.activeTabItem]

			try {
				const offset = (this.currentPage - 1) * 10
				let requestOptions = options || {
					off: this.off,
					to: this.to,
					name: this.search,
					limit: 10,
					offset,
					manager: this.selectedManager,
					is_ppg: this.selectedOrderType,
					cid: this.cid,
					phone: this.phone,
					author: this.selectedAuthor,
					client: this.selectedClient,
					website: this.selectedWebsite,
					level: this.selectedLevel,
					work: this.selectedWork,
					id: this.id,
					sortType: this.sortType,
					sortKey: this.sortKey
				};

				requestOptions.type = item.key;
				let dataTickets = await this.dbGetFilteredTickets(requestOptions);
				// this.orders[item.key] = dataTickets.data;

				this.totalTickets = dataTickets.count
				this.orders[item.key] = []

				for (let i = 0; i < offset; i++) {
					this.orders[item.key][i] = dataTickets.data[0];
				}


				for (let i = 0; i < dataTickets.data.length; i++) {
					this.orders[item.key][offset + i] = dataTickets.data[i]
				}

				// this.orders[item.key].forEach(el => {
				// 	el.pages_number = +el.pages_number
				// 	return el;
				// })

				this.addSortWrappers(item);

			} catch (e) {
				this.notifyError(e.message);
			}

			// this.sortTickets();
		},

		async setActiveTab(data) {
			const prev = this.activeTabItem;
			this.activeTabItem = data;

			if (prev === data) {
				return;
			}
			this.sortType = null;

			this.currentPage = 1
			this.setPageNumber(this.currentPage)
			await this.filter();
			let title = this.tabs[prev].key;
			this.orders[title] = [];
			await this.$router.replace({query: {tab: this.tabs[data].key}}).catch((err) => {
			});
		},

		async setPageNumber(data, makeRequest = true) {
			this.currentPage = data;
			await this.$router.replace({query: {...this.$route.query, page: data}}).catch((err) => {
			})

			if (makeRequest !== false) {
				await this.filter()
			}
		},
	},

	watch: {
		async sortType(newVal) {
			await this.filter()
			await this.filterCountNoReplyOrder()
		},
		async selectedOrderType() {
			this.setPageNumber(1, false)
			let item = this.tabs[this.activeTabItem]
			this.orders[item.key] = []

			await this.$nextTick(async () => {
				await this.filter()
				await this.filterCountNoReplyOrder()
			})
		},
		async off(value) {
			if (value) {
				this.setPageNumber(1, false)
			}
			await this.filter();
			await this.filterCountNoReplyOrder()
			if (this.$store.state.auth.role === "manager") return
			if (this.to !== '' && value !== '') {
				this.checkInvoices(this.off, this.to)
				this.checkPayoutActs(this.off, this.to)
			}
		},
		async to(value) {
			if (value) {
				this.setPageNumber(1, false)
			}
			await this.filter();
			await this.filterCountNoReplyOrder()
			if (this.$store.state.auth.role === "manager") return
			if (this.off !== '' && value !== '') {
				this.checkInvoices(this.off, this.to)
				this.checkPayoutActs(this.off, this.to)
			}
		},
		activePrompt(value) {
			if (value) return;
			this.date = new Date();
			this.about = '';
		},
		async selectedManager() {
			this.setPageNumber(1, false)
			let item = this.tabs[this.activeTabItem]
			this.orders[item.key] = []

			await this.$nextTick(async () => {
				await this.filter()
				await this.filterCountNoReplyOrder()
			})
		}

	},
	computed: {
		filteredManagers() {
			if (this.managers.length) {
				this.managers.map((el) => {
					el.full_name = `${el.first_name} ${el.last_name}`
				})
				return this.managers
			}
			return []
		},
		isNotCompleted() {
			return this.tabs[this.activeTabItem].key !== 'completed'
				&& this.tabs[this.activeTabItem].key !== 'failed_with_payout'
				&& this.tabs[this.activeTabItem].key !== 'failed';
		},
		minDate() {
			return new Date();
		},
		searchedOrders() {
			return this.orders;
		},
		pathToAuthor() {
			if (this.$store.state.auth.role === "admin") {
				return 'author';
			} else if (this.$store.state.auth.role === "manager") {
				return 'authorM';
			}
		},
		pathToClient() {
			if (this.$store.state.auth.role === "admin") {
				return 'client';
			} else if (this.$store.state.auth.role === "manager") {
				return 'clientM';
			}
		},
	},
	created() {
		const role = this.$store.state.auth.role;
		const headers = orderHeadersList.getHeaders(role);
		this.field = headers.field;
		this.tabs = headers.tabs;

		const tabIndex = this.tabs.findIndex((el) => el.key === this.$route.query.tab)

		const queryPage = this.$route.query.page;
		if (queryPage !== undefined) {
			this.currentPage = +queryPage;
		}

		if (tabIndex !== -1) {
			this.activeTabItem = tabIndex;
		}
	},
	async mounted() {
		this.$nextTick(async () => {
			const role = this.$store.state.auth.role;

			const requests = [
				async () => {
					if (role === "author") {
						this.tasks = (await this.$http.get("/" + role + "/order")).data.data;
					} else {
						this.tasks = (await this.$http.get("/" + role + "/task")).data.data;
					}
				},
				async () => {
					this.levels = (
						await this.$http.get("/settings/get-quality-levels")
					).data.data;
				},
				async () => {
					this.works = (await this.$http.get("/settings/get-work-types")).data.data;
				},
				async () => {
					this.subjects = (await this.$http.get("/settings/get-subjects")).data.data;
				},
				async () => {
					if (role === 'admin' || role === 'manager') {
						this.managers = (await this.dbGetMangers())
					}
				},
			]

			await Promise.all(requests.map(item => item()))

			if (role === 'manager') {
				const res = (await this.$http.get('/manager/profile')).data.data
				this.selectedManager = res.id
			} else {
				await this.filter();
				await this.filterCountNoReplyOrder()
			}
		})
	},
};
</script>

<style lang="scss">
@import "../../assets/scss/vuexy/variables.scss";
@import "../../assets/scss/vuexy/functions.scss";

.text-orange {
	color: #ff1a00 !important;
}

.agent-circle-wrapper {
	display: flex;
	justify-content: center;
	align-items: center;
}

.agent-circle {
	width: 16px;
	height: 16px;
	border: 2px solid;
	border-radius: 50%;
	background-color: white; /* дырка */
}

.agent-red {
	border-color: red;
}

.agent-green {
	border-color: green;
}

.download__container {
	display: flex;
	flex-wrap: wrap;
	grid-gap: 10px;

	.vs-button-text {
		display: flex;
		align-items: center;
		justify-content: center;

		@media screen and (max-width: 576px) {
			width: 100%;
		}

		.feather-icon {
			margin-left: 10px;
		}
	}
}

.con-exemple-prompt {
	.append-text {
		height: 2.7rem;
	}

	.vs-button {
		border-left: 0;
	}

	.vx-input-group-append {
		align-items: flex-end;
	}

	.vs-input {
		width: 100%;

		textarea {
			resize: none;
		}
	}
}

.viewTask {
	.vs-popup--title h3 {
		color: $primary;
	}

	.vs-popup--content {
		padding: 0;
	}

	.vs-popup--close {
		color: $primary;
	}

	table {
		width: 100%;

		td {
			padding-bottom: 4px;
		}
	}

	.body {
		padding: 1rem;

		table {
			margin-left: -2px;
		}

		p {
			padding-top: 10px;
			font-size: rem(14px);
		}
	}

	.footer {
		border-top: 1px solid rgba(0, 0, 0, 0.05);
		padding: 0.5rem 1rem;
		display: flex;
		justify-content: flex-end;

		button {
			margin-left: 10px;
		}
	}
}

.Tickets {
	.buttons {
		justify-content: flex-end;
	}

	.button-task {
		border-radius: 22px;
		padding: 0.25rem 0.7rem !important;
	}

	.add-affair_admin {
		margin-right: 25px;
	}

	.author-header {
		display: flex;
		justify-content: center;
	}

	.deal-today {
		background-color: #FBE3C5;
	}

	.tickets__datepicker {
		@media screen and (max-width: 1400px) and (min-width: 1301px) {
			width: 160px !important;
		}

		@media screen and (max-width: 1300px) and (min-width: 1201px) {
			width: 130px !important;
		}
	}


	.filter {
		border-bottom: 1px solid #e5e5e5;
		padding-bottom: 1rem;
		padding-top: 0.5rem;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;

		.date {
			display: flex;
			align-items: center;
		}

		.vx-input-group .vx-input-group-default .vs-input {
			width: 150px;
		}

		.search .vs-icon {
			height: 100%;
			width: 35px;
			background: $primary;
			position: absolute;
			top: 0;
			right: 0;
			color: white !important;
			display: flex;
			align-items: center;
			justify-content: center;
			border-top-right-radius: 4px;
			border-bottom-right-radius: 4px;
			font-size: 22px;
		}

		.search .vs-con-input-label {
			width: 260px;

			@media screen and (max-width: 1200px) {
				width: 100%;
			}
		}
	}

	.vs-table {
		margin-top: 10px;

		tr {
			border-top: 1px solid #cfcfcf;

			&:last-child {
				border-bottom: 1px solid #cfcfcf;
			}
		}
	}

	.con-vs-tabs .con-slot-tabs {
		overflow: visible;
	}

	.task {
		background-color: #3ac47d;
		border-radius: 10px;
		padding: 4px 10px;
		color: white;
	}

	.counters__container {
		display: flex;
		justify-content: space-between;
		width: 45px;

		.counter {
			display: inline-block;
			padding: 5px;
			border-radius: 100%;
			font-weight: 600;
			width: 20px;
			height: 20px;
			font-size: 0.7rem;
			border: 1px solid #cfcfcf;
			display: flex;
			align-items: center;
			justify-content: center;
			line-height: 1;

			&.warn {
				background-color: #f0ad4e;
				color: white;
				border-color: #f0ad4e;
			}

			&.blue {
				background-color: #005f95;
				color: white;
				border-color: #005f95;
			}
		}
	}


	.fade-enter-active,
	.fade-leave-active {
		transition: opacity 0.5s;
	}

	.inputInTable {
		border: 0;
		resize: none;
	}

	.fade-enter, .fade-leave-to {
		opacity: 0;
	}

	.buttons {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		@media screen and (max-width: 375px) {
			button {
				margin: 5px 0;
			}
		}
	}

	.vs-tabs--li button.vs-tabs--btn {
		padding: 10px 16px;
	}

	.vs-tabs--content {
		padding: 0;
		margin-top: 10px;
	}

	.vs-con-table .vs-con-tbody {
		border: 0;
		background-color: transparent;
	}

	.vs-table-text {
		cursor: pointer;
		user-select: none;
	}
}
</style>
